import React, { useEffect } from "react"
import assetSidebars from "stores/assetSidebars"
import { useList, useUnit } from 'effector-react'
import AssetSidebar, { IAssetSidebarProps, AssetSidebarTab } from "components/AssetSidebar/AssetSidebar"
import { useLocation } from "react-router-dom"
import pendingAssetSidebarStore from "stores/pendingAssetSidebar"

const AssetSidebars = () => {
    const location = useLocation()
    const pendingAssetSidebar = useUnit(pendingAssetSidebarStore.$pendingAssetSidebar)

    useEffect(() => {
        const navState = location.state as { openAssetSidebarId?: string, tab?: AssetSidebarTab } | null
        if (navState?.openAssetSidebarId) {
            assetSidebars.show({ assetId: navState.openAssetSidebarId, initTabId: navState.tab })
            return
        }
        if (pendingAssetSidebar.assetId) {
            return
        }
        assetSidebars.clear()
    }, [location.pathname])

    async function handleClose(props: IAssetSidebarProps) {
        if (typeof props.onClose === "function") {
            props.onClose()
        }
        assetSidebars.hide(props)
    }

    return (
        <>
            {useList(assetSidebars.list, (props: IAssetSidebarProps, idx) => (
                <AssetSidebar
                    key={idx}
                    {...props}
                    onClose={() => handleClose(props)}
                />
            ))}
        </>
    )
}

export default AssetSidebars
